import { useState, useContext, ChangeEvent } from "react"
import { useHttp } from "../hooks/http.hook"
import { AuthContext } from "../context/authContext"
import { LoadingBar } from "./loadingBar"

export const CheckUpComponent = (props: {page :string}) => {
    const auth = useContext(AuthContext)
    const { loading, request, error, clearError } = useHttp()
    const [robot, setRobot] = useState('')
    const [status, setStatus] = useState(null)

    const selectRobot = async (e: ChangeEvent) => {
      // @ts-ignore
      setRobot(e.target?.value)
      clearError()
      setStatus(null)
    }

    const checkRobot = () => {
      clearError()
      setStatus(null)
      request('/products/checkUp', "POST", { robot }, {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.token}`
      }).then((req)=> {
        setStatus(req.status)
      })
    }

    return(
      <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
        <h4>{props.page.toLocaleUpperCase()}</h4>
        <span style={{color: "sienna", opacity: 0.7}}>Проверка роботов на доступность в Китайской сети</span>
        <span style={{color: "sienna", opacity: 0.7}}>Принцип: Происходит имитация робота на основной домен робота (например: www.abcam.cn) и проверяется доступность в течении 1 минуты.</span>
        <span style={{color: "sienna", opacity: 0.7}}>Если сайт недоступен или нет основного тега наименования сайта (так же возможны сценарии когда сайты ставят защиту от роботов), робот пишет рекомендацию.</span>
        <div className="input-field" style={{width: '80%', marginTop: '2em', display: 'flex', flexDirection: 'column'}}>
          <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '1em'}}>
            {['Abcam', 'Abclonal', 'Acmec (API)', 'Aladdin', 'Bioec (Site + API)', 'CST', 'Heqi', 'Macklin (Site + API)', 'MedChemExpress'].map((item) =>
              <label style={{display: 'flex', marginRight: '2em'}} key={"sku" + item}>
                <input type="radio" name="robot" className="filled-in" value={item.split(' ').at(0)} onChange={selectRobot} disabled={loading} />
                <span>{item}</span>
              </label>
            )}
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            {['Miltenyi Biotec (API)', 'Neobioscience', 'Promega', 'Servicebio', 'Sigma', 'Synthware', 'TargetMol', 'Thermo Fisher Scientific', 'Thermo Fisher Scientific Antibodies TF'].map((item) =>
              <label style={{display: 'flex', marginRight: '2em'}} key={"sku" + item}>
                <input type="radio" className="filled-in" value={item.split(' ').at(0)} name="robot" onChange={selectRobot} disabled={loading} />
                <span>{item}</span>
              </label>
            )}
          </div>
          <div style={{display: 'flex', marginTop: '2em', justifyContent: 'center'}}>
            <button className="waves-effect waves-light btn" disabled={loading} onClick={checkRobot}>Проверить</button>
          </div>
          <div style={{marginTop: "4em"}}>
            { error && <div className="red-text center-align">{error}</div> }
            { loading && <LoadingBar text='Идет проверка робота'/> }
            { robot && status && <div className="green-text center-align">Робот {robot} -- Работает!</div> }
            { robot && status === false && <div className="red-text center-align">Робот {robot} -- Не работает! Обратитесь к девопсам за проверкой сети. Если сайт доступен в Китайской сети, то обратитесь к разработчику.</div> }
          </div>
        </div>
      </div>
    )
}